import { BASE_URL } from "@/services/api/base";

export const getVerifiedUserEndpoint = `${BASE_URL}/Users/VerifiedUser`;
export const getLoggedInUserEndpoint = `${BASE_URL}/Users/GetLoggedInUser`;

export const getContactPersonsEndpoint = `${BASE_URL}/Users/ContactPersons`;
